import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Measure from 'react-measure';
import { get } from 'lodash';
import LightboxGallery from './LightboxGallery';
import { getThumborURL } from '../../utils/thumbor';

export const WIDTH_IN_REM = 4; // Includes margin
export const REM_TO_PX = 16;
export const THUBOR_SIZE = '48x56';

const howManyCanFit = width => Math.floor(width / (WIDTH_IN_REM * REM_TO_PX));

const ImageStyle = css`
  width: 3.5rem;
  height: 3rem;
  border-radius: 10px;
  margin: 0.25rem;
  object-fit: cover;
  cursor: pointer;
  display: inline-block;
  vertical-align: bottom;
`;
export const Image = styled.img`
  ${ImageStyle};
`;
export const MoreImages = styled.div`
  ${ImageStyle}
  background: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${props => props.bg});
  background-size: cover;
  position: relative;
  color: #fff;
  text-align: center;
  padding: 1rem;
`;

export default class AttachmentsList extends Component {
  static propTypes = {
    attachments: PropTypes.array
  };

  state = {
    lightboxOpen: false,
    initialIndex: 0
  };

  openImage(index) {
    this.setState({
      lightboxOpen: true,
      initialIndex: index
    });
  }

  closeLightbox() {
    this.setState({
      lightboxOpen: false,
      initialIndex: 0
    });
  }

  render() {
    const { attachments } = this.props;
    const { lightboxOpen, initialIndex } = this.state;
    return (
      attachments.length && (
        <Measure client>
          {({ measureRef, contentRect = { client: { width: 400 } } }) => {
            const numberImages = howManyCanFit(get(contentRect, 'client.width', 400));
            const numberThumbnails =
              numberImages >= attachments.length ? numberImages : numberImages - 1;
            const showMore = numberImages < attachments.length && numberImages > 0;
            const moreCount = attachments.length - numberThumbnails;
            return (
              <div ref={measureRef}>
                <LightboxGallery
                  images={attachments}
                  isOpen={lightboxOpen}
                  initialImageIndex={initialIndex}
                  onRequestClose={() => this.closeLightbox()}
                />
                {attachments.slice(0, numberThumbnails).map(({ id, url, filename }, index) => (
                  <Image
                    key={id}
                    src={getThumborURL(url, THUBOR_SIZE)}
                    alt={filename}
                    onClick={() => this.openImage(index)}
                  />
                ))}
                {showMore && (
                  <MoreImages
                    bg={getThumborURL(attachments[Math.min(numberThumbnails)].url, THUBOR_SIZE)}
                    onClick={() => this.openImage(numberThumbnails)}
                  >
                    +{moreCount}
                  </MoreImages>
                )}
              </div>
            );
          }}
        </Measure>
      )
    );
  }
}
